export default __webpack_public_path__ + "static/media/3.dc4858fe.png";